// src/shared/MeetingEnded.jsx
import React, { useEffect, useState, useContext } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { AuthContext } from '../auth/AuthContext';

export default function MeetingEnded() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const sid = params.get('sid');
  const { isAuthenticated, role } = useContext(AuthContext);
  const normalizedRole = role === 'tutor' ? 'educator' : role;
  // Decide where to send them based on role
  const destination = !isAuthenticated
    ? '/login'
    : normalizedRole === 'educator'
      ? '/educator'
      : normalizedRole === 'student'
        ? '/student/dashboard'
        : '/login';

  // Optional: show a short countdown before redirect
  const [seconds, setSeconds] = useState(5);

  useEffect(() => {
    const t = setInterval(() => setSeconds((s) => Math.max(0, s - 1)), 1000);
    return () => clearInterval(t);
  }, []);

  useEffect(() => {
    const t = setTimeout(() => navigate(destination, { replace: true }), 5000);
    return () => clearTimeout(t);
  }, [navigate, destination]);

  const goNow = () => navigate(destination, { replace: true });

  // Small role label for clarity
  const roleLabel = !isAuthenticated ? 'guest' : normalizedRole || 'guest';

  return (
    <div style={styles.wrap}>
      <div style={styles.card} role="status" aria-live="polite">
        <h2 style={{ margin: 0 }}>Meeting Ended</h2>
        <p style={{ marginTop: 8 }}>
          {sid ? <>Session <code>{sid}</code> has ended.</> : 'Your session has ended.'}
        </p>
        <p style={{ marginTop: 8 }}>
          Redirecting {roleLabel ? `(${roleLabel}) ` : ''}to your dashboard in <strong>{seconds}</strong>s...
        </p>
        <button style={styles.btn} onClick={goNow} aria-label="Go to dashboard now">
          Go now
        </button>
      </div>
    </div>
  );
}

const styles = {
  wrap: { minHeight: '60vh', display: 'grid', placeItems: 'center', padding: 24 },
  card: {
    background: '#fff',
    borderRadius: 16,
    padding: 24,
    width: 'min(100%, 520px)',
    boxShadow: '0 10px 24px rgba(0,0,0,.08)',
    textAlign: 'center'
  },
  btn: {
    marginTop: 12,
    padding: '10px 14px',
    borderRadius: 10,
    fontWeight: 700,
    cursor: 'pointer',
    border: 'none',
    background: '#00154A',
    color: '#fff'
  }
};
